import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import { presetStateSelector } from "../utils/state.js";
export const setMapkaApiKey = createAction("apiKey/setApiKey");
const initialApiKey = {};
export const apiKeyReducer = createReducer(initialApiKey, (builder) => {
    builder.addCase(setMapkaApiKey, (state, { payload }) => {
        state.mapkaAPIKey = payload;
    });
});
export const getApiKeyState = createSelector([presetStateSelector], state => state.apiKey);
export const getApiKey = createSelector([getApiKeyState], state => state.mapkaAPIKey);
